// extracted by mini-css-extract-plugin
module.exports =  {"warning-message":"AXjGJ8D","warningMessage":"AXjGJ8D"};